import { useEffect, useState } from 'react';

/** True when the current viewport is mobile-sized (≤ 768px wide). */
export function useIsMobileViewport(): boolean {
  const get = () => typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
  const [isMobile, setIsMobile] = useState<boolean>(get());

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    // Safari < 14 doesn't support addEventListener on MediaQueryList
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', handler);
      else mq.removeListener(handler);
    };
  }, []);

  return isMobile;
}

const PREF_KEY = 'riskninja-mobile-pref';
export type MobilePref = 'auto' | 'mobile' | 'desktop';

export function getMobilePref(): MobilePref {
  try {
    const v = localStorage.getItem(PREF_KEY);
    return v === 'mobile' || v === 'desktop' ? v : 'auto';
  } catch { return 'auto'; }
}

export function setMobilePref(p: MobilePref) {
  try { localStorage.setItem(PREF_KEY, p); } catch {}
}
